import React from 'react'
import { constants } from 'common/helpers'

import { Box } from 'components/_new/layout'
import { Button } from 'components/_new/controls'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './EmailSuggestionView.scss'


type EmailSuggestionViewProps = {
  domain: string
  onConfirm: () => void
}

const EmailSuggestionView: React.FunctionComponent<EmailSuggestionViewProps> = ({ domain, onConfirm }) => {
  return (
    <Box mt={8} pr={8} pl={16} noWrapper>
      <div
        className={s.emailSuggestion}
        role="region"
        aria-live="polite"
        data-testid={constants.testIds.register.emailSuggestion}
      >
        <Box pt={12} pb={12}>
          <Text size="16-24" message={{ ...messages.text, values: { domain } }} html />
        </Box>
        <Button
          className={s.button}
          title={messages.button}
          type="button"
          color="transparent"
          size="xs"
          onClick={onConfirm}
        />
      </div>
    </Box>
  )
}


export default EmailSuggestionView
